import type { FocusEvent } from "react";
import { CircleHelp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@headerhawk/ui";

interface InfoTooltipProps {
  content: string;
}

/**
 * Opens on focus only when the focus is a keyboard user's. A dialog focuses
 * the first thing it can on opening, which is often one of these, and the
 * tooltip that popped open then took the first Escape meant for the dialog.
 * (While the window scrolled, a scroll event happened to close it; since
 * only the dashboard's <main> scrolls, nothing does.)
 */
function openOnKeyboardFocusOnly(event: FocusEvent<HTMLButtonElement>) {
  let keyboard = true;
  try {
    keyboard = event.currentTarget.matches(":focus-visible");
  } catch {
    // A browser without :focus-visible opens it, as before.
  }
  // Radix skips its own focus handler when this one prevents the default.
  if (!keyboard) event.preventDefault();
}

export function InfoTooltip({ content }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild onFocus={openOnKeyboardFocusOnly}>
        <button
          type="button"
          className="inline-flex ml-1 align-middle text-muted-foreground hover:text-foreground"
        >
          <CircleHelp className="h-3.5 w-3.5" />
          <span className="sr-only">More info</span>
        </button>
      </TooltipTrigger>
      <TooltipContent>{content}</TooltipContent>
    </Tooltip>
  );
}
